<template>
  <div class="d-flex flex-md-column flex-row justify-content-center m-2 m-md-0">
    <div>
      <span class="d-flex text-nowrap">
        <slot></slot>
        <div class="d-print-none">
          <az-float-panel
            classe="left"
            :title="status.msg"
            :icon="status.icon + ' fa-fw mr-1'"
            :sync="sync"
            :block="!hor || !hor.marcacao"
            :action="editar"
            v-if="showPrint"
          >
            <div v-if="conteudo">
              <div class="d-flex">
                <h4 class="mb-2">{{ conteudo.item_status.valor }}</h4>
                <div v-if="conteudo.id_atendimento">
                  <span class="small ml-3">#{{ conteudo.id_atendimento }}</span>
                  <small class="small text-muted ml-3" v-if="conteudo.st_id_externo">{{ conteudo.st_id_externo }}</small>
                </div>
              </div>
              <div v-if="conteudo.fl_tele_atendimento">
                <i class="fas fa-satellite-dish mr-2"></i>
                Teleatendimento 
              </div>

              <!-- Marcação Original da Remarcação -->
              <div class="small" v-if="conteudo.remarcacao_origem">
                <span class="text-muted">Marcado Origem:</span>
                <span v-if="conteudo.remarcacao_origem.dt_marcacao">
                  {{ $util.getFormatDate(conteudo.remarcacao_origem.dt_marcacao).substr(0,5) }}
                  {{ conteudo.remarcacao_origem.dt_marcacao.substr(11,5) }}
                </span>
                <i class="fa fa-caret-right mx-1 text-muter" aria-hidden="true"></i>
                <span class="badge badge-secondary" v-if="conteudo.remarcacao_origem.fl_portal">portal</span>
                <span v-else>{{ conteudo.remarcacao_origem.usuario.search }}</span>
              </div>

              <!-- Marcação -->
              <div class="small" v-if="conteudo.fl_oferta">
                <i class="fas fa-sun mr-2"></i>
                Ofertado pela Clínica
              </div>

              <div class="small">
                <span class="text-muted">{{ conteudo.remarcacao_origem ? 'Remarcado:' : 'Marcado:' }}</span>
                <span v-if="conteudo.dt_marcacao">
                  {{ $util.getFormatDate(conteudo.dt_marcacao).substr(0,5) }}
                  {{ conteudo.dt_marcacao.substr(11,5) }}
                </span>
                <i class="fa fa-caret-right mx-1 text-muter" aria-hidden="true"></i>
                <span class="badge badge-secondary" v-if="conteudo.fl_portal">portal</span>
                <span v-else>{{ conteudo.usuario.search }}</span>

                <div v-if="conteudo.dt_inicio && ( conteudo.dt_inicio.substr(0,10) == $util.hoje() && conteudo.ch_estado_marcacao == 'A' && conteudo.st_codigo_reserva )">
                  <span class="text-muted">Cód. Reserva:</span>
                  {{ conteudo.st_codigo_reserva }}
                </div>
              </div>

              <!-- Marcação Destino da Remarcação -->
              <div class="small" v-if="conteudo.remarcacao_destino">
                <span class="text-muted">Remarcado para:</span>
                <span v-if="conteudo.remarcacao_destino.dt_marcacao">
                  {{ $util.getFormatDate(conteudo.remarcacao_destino.dt_marcacao).substr(0,5) }}
                  {{ conteudo.remarcacao_destino.dt_marcacao.substr(11,5) }}
                </span>
                <i class="fa fa-caret-right mx-1 text-muter" aria-hidden="true"></i>
                <span class="badge badge-secondary" v-if="conteudo.remarcacao_destino.fl_portal">portal</span>
                <span v-else>{{ conteudo.remarcacao_destino.usuario.search }}</span>
              </div>

              <div class="small" v-if="conteudo.dt_checkin">
                <span class="text-muted">Check-in:</span>
                <span>
                  {{ $util.getFormatDate(conteudo.dt_checkin).substr(0,5) }}
                  {{ conteudo.dt_checkin.substr(11,5) }}
                </span>
                <span v-if="conteudo.usuario_checkin && conteudo.usuario_checkin.search">
                  <i class="fa fa-caret-right mx-1" aria-hidden="true"></i>
                  {{ conteudo.usuario_checkin.search }}
                </span>
                <span v-if="conteudo.st_checkin_origem">
                  <span class="badge badge-success ml-1">
                    {{ conteudo.st_checkin_origem }}
                  </span>
                </span>
              </div>
              
              <div class="small" v-if="conteudo.id_atendimento && conteudo.atendimento.id_usuario">
                <div v-if="conteudo.atendimento.id_usuario">
                  <span class="text-muted">Atendido:</span>
                  <span v-if="conteudo.atendimento.created_at">
                    {{ $util.getFormatDate(conteudo.atendimento.created_at).substr(0,5) }}
                    {{ conteudo.atendimento.created_at.substr(11,5) }}
                  </span>
                  <i class="fa fa-caret-right mx-1 text-muter" aria-hidden="true"></i>
                  {{ conteudo.atendimento.usuario.search }}
                </div>
                
              </div>

              <!-- Confirmação -->
              <div class="mt-3" v-if="conteudo.historico_status_marcacao">
                <span>{{ conteudo.historico_status_marcacao.id_status_marcacao == 2 ? 'Confirmado' : 'Sem Retorno' }}</span>
                <div v-if="conteudo.historico_status_marcacao.dt_mudanca_status != conteudo.dt_marcacao">
                  <small v-if="conteudo.historico_status_marcacao.usuario">{{ conteudo.historico_status_marcacao.usuario.st_login }} em </small>
                  <small class="text-muted" v-if="conteudo.historico_status_marcacao.dt_mudanca_status">
                    {{ $util.getFormatDate (conteudo.historico_status_marcacao.dt_mudanca_status) }}
                    {{ conteudo.historico_status_marcacao.dt_mudanca_status.substr(11,5) }}
                  </small>
                </div>
                <div class="small text-muted" v-if="conteudo.historico_status_marcacao.st_observacao">{{ conteudo.historico_status_marcacao.st_observacao }}</div>
              </div>

              <!-- Bloqueio -->
              <div class="mt-3" v-if="conteudo.id_bloqueio">
                <div>
                  <span class="text-muted">Bloqueado por:</span>
                  {{ conteudo.bloqueio.usuario.search }}
                </div>
                <div v-if="conteudo.bloqueio.dt_bloqueio">
                  <span class="text-muted">Bloqueado em:</span>
                  {{ $util.getFormatDate(conteudo.bloqueio.dt_bloqueio) }}
                  {{ conteudo.bloqueio.dt_bloqueio.substr(11,5) }}
                </div>
                <div>
                  <span class="text-muted">Motivo:</span>
                  {{ conteudo.bloqueio.bloqueio_motivo.search }}
                </div>
              </div>
              <!-- Cancelamento -->
              <div class="mt-3" v-if="conteudo.dt_cancelamento">
                <div v-if="conteudo.usuario_cancelamento">
                  <span class="text-muted">Cancelado por:</span>
                  {{ conteudo.usuario_cancelamento.st_login }}
                </div>
                <div v-if="conteudo.dt_cancelamento">
                  <span class="text-muted">Cancelado em:</span>
                  {{ $util.getFormatDate(conteudo.dt_cancelamento) }}
                  {{ conteudo.dt_cancelamento.substr(11,5) }}
                </div>
                <div>
                  <span class="text-muted">Motivo:</span>
                  {{ conteudo.st_motivo_cancelamento }}
                </div>
              </div>
            </div>
            <div v-else>
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </az-float-panel>
        </div>

        <slot name="info" :metodo_abrir_tempos="abrir_tempos"></slot>

        <template v-if="!onlyPanel">
          <span class="mr-3" data-toggle2="tooltip" data-placement="top" title="Horário da Marcação" v-if="hor">
            <a href="#" @click.prevent="abrir_tempos()" class="card-link">
              <span v-if="hor.hg">
                {{ hor.hg }}
              </span>
              <span v-else>
                {{ hor.hora ? hor.hora : ( ( hor.marcacao && hor.marcacao.dt_inicio ) ? hor.marcacao.dt_inicio.substr(11,5) : '' ) }}
              </span>
            </a>

            <a href="#" @click.prevent="pesquisar('#autoagendamento')" v-if="hor && hor.marcacao && hor.marcacao.fl_portal" class="ml-2 small" title="Auto Agendamento.">
                <i class="fa-solid fa-globe-pointer"></i>
            </a>

            <span class="ml-2 small text-muted" v-if="hor.marcacao && hor.marcacao.id_atendimento">#{{ hor.marcacao.id_atendimento }}</span>

            <span class="badge badge-secondary ml-1" v-if="hor.marcacao && hor.marcacao.in_slots > 1"
              data-toggle2="tooltip" data-placement="top" :title="'Ocupando ' + hor.marcacao.in_slots + ' horários da agenda (até ' 
                + (hor.marcacao.dt_termino ? hor.marcacao.dt_termino.substr(11,5) : '') + ')'">
              {{ hor.marcacao.in_slots }}
            </span>

            <span class="ml-2" v-if="hor.marcacao && !hor.marcacao.id_atendimento && hor.marcacao.estoque_solicitacoes_count" title="Solicitação de Estoque Vinculada">
                <i class="fa-solid fa-boxes-packing text-muted"></i>
            </span>
            
            <span v-if="!hor.marcacao && hor.unidade_operacao && hor.unidade_operacao.st_sigla" class="badge badge-light">
              {{ hor.unidade_operacao.st_sigla }}
            </span>
          </span>
          <span class="mr-2" data-toggle2="tooltip" data-placement="top" title="Conectado com Sistema de Chamada" 
            v-if="hor && hor.marcacao && hor.marcacao.telegram_chat_id">
            <i class="fab fa-telegram-plane text-info"></i>
          </span>
          <span class="mr-2" data-toggle2="tooltip" data-placement="top" title="Conectado com Sistema de Chamada" 
            v-if="1==0 && hor && hor.marcacao && hor.marcacao.whatsapp_number">
            <i class="fab fa-whatsapp text-success"></i>
          </span>

          <i class="fas fa-satellite-dish text-muted mr-2" data-toggle="tooltip" data-placement="top" title="Teleatendimento" v-if="hor && hor.marcacao && hor.marcacao.fl_tele_atendimento"></i>

          <a href="#" @click.prevent="editar(hor.marcacao)" class="card-link">
            <i class="mr-2" 
              :class="( hor.marcacao.sinalizador_atendimento.st_icon ? hor.marcacao.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + hor.marcacao.sinalizador_atendimento.st_cor"
              data-toggle2="tooltip" data-placement="top" 
              :title="hor.marcacao.sinalizador_atendimento.search" 
              v-if="hor && hor.marcacao && hor.marcacao.sinalizador_atendimento"></i>
          </a>

          <!-- Sinalização de Extra -->
          <span class="small text-muted mr-2" v-if="false && hor.marcacao && hor.marcacao.fl_extra">Extra</span>
          <!-- Sinalização de Extra -->
          
          <template v-if="hor && hor.marcacao && hor.marcacao.pagamento_online">
            <div class="spinner-border spinner-border-sm" role="status" v-if="confirmando_pagamento">
              <span class="sr-only">Loading...</span>
            </div>
            <template v-else>
              <i class="fas fa-dollar-sign text-success mr-2" v-if="hor.marcacao.pagamento_online.ch_status == 'P'" 
                data-toggle="tooltip" data-placement="top"  title="Pagamento On-line realizado."></i>
              
              <a href="#" @click.prevent="verificarPagamento()">
                <i class="fas fa-dollar-sign text-danger mr-2" v-if="hor.marcacao.pagamento_online.ch_status == 'E'" 
                  data-toggle="tooltip" data-placement="top"  title="Pagamento On-line Pendente. Clique aqui para verificar se foi realizado."></i>
              </a>
            </template>
          </template>       
        </template>

      </span>
    </div>
    <div v-if="!onlyPanel">
      <span
        data-toggle2="tooltip"
        data-placement="top"
        title="Horário do CheckIn"
        v-if="hor.marcacao && hor.marcacao.dt_checkin"
      >
        <i class="fas fa-user-check fa-fw mr-1"></i>
        {{ getHora (hor.marcacao.dt_checkin) }}
        <span title="Atrasado" class="text-danger small"
          v-if="!emergencia 
          && !hor.marcacao.fl_adicao_direta 
          && !hor.marcacao.fl_ordem_chegada 
          && hor.marcacao.dt_inicio.substr(0,10) == $util.hoje() 
          && hor.marcacao.dt_inicio.substr(11,5) < hor.marcacao.dt_checkin.substr(11,5)">
          Atrasado
          <span class="badge badge-danger">
            {{ calc_atraso(hor) }}min
          </span>
        </span>  

        <!-- TESTE -->
        <span title="Tempo de Espera" class="text-muted small"
          v-if="false && emergencia && hor.marcacao.dt_inicio.substr(0,10) == $util.hoje()">
          {{ hor.marcacao.item_status.valor }}
        </span>  
        <!-- TESTE -->
      </span>
      <span
        data-toggle2="tooltip"
        data-placement="top"
        title="Horário de Chegada"
        v-else-if="hor.marcacao && hor.marcacao.atendimento"
      >
        <i class="fas fa-user-clock fa-fw mr-1"></i>
        {{ getHora (hor.marcacao.atendimento.dt_inicio) }}
        <span title="Atrasado" class="text-muted small"
          v-if="hor.marcacao.dt_inicio.substr(0,10) == $util.hoje() 
          && !hor.marcacao.fl_adicao_direta
          && !hor.marcacao.fl_ordem_chegada 
          && hor.marcacao.dt_inicio.substr(11,5) < ( hor.marcacao.dt_checkin ? hor.marcacao.dt_checkin : hor.marcacao.atendimento.dt_inicio ).substr(11,5)">
          Atrasado
        </span>  
      </span>
      <span v-else-if="hor.marcacao && hor.marcacao.ch_estado_marcacao == 'A' 
        && !hor.marcacao.fl_adicao_direta
        && !hor.marcacao.fl_ordem_chegada 
        && hor.marcacao.dt_inicio.substr(0,10) == $util.hoje() && hor.marcacao.dt_inicio.substr(11,5) < $util.agora()">
        Atrasado
      </span>

      <span class="ml-2 small text-muted" v-if="hor.marcacao && hor.marcacao.st_id_externo">{{ hor.marcacao.st_id_externo }}</span>
    </div>

    <!-- Modal -->
    <template v-if="exibir_tempos && hor && hor.marcacao">
      <div class="modal fade" :id="'exibirTemosModal' + hor.marcacao.id_marcacao" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Tempo de Atendimento: 
                {{ hor.marcacao.nome_paciente }}
                <span v-if="hor.marcacao.id_atendimento" class="ml-3">
                  #{{ hor.marcacao.id_atendimento }}
                </span>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="lead">
                {{ hor.marcacao.procedimento.search }}
              </div>
              <div class="mb-3">
                {{ hor.marcacao.medico.search }}
              </div>
              <p class="alert alert-dark" v-if="!hor.marcacao.fl_adicao_direta">
                Agendado para: {{ $util.getFormatDate(hor.marcacao.dt_inicio) }}
                {{ hor.marcacao.dt_inicio.substr(11,5) }}
              </p>

              <!-- Tempos -->
              <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between" v-if="tempo_antecedencia">
                  <span class="text-muted">Chegada com Antecedência:</span> 
                  <span>
                    {{ seconds_to_time(tempo_antecedencia) }}
                    <i class="fas fa-stopwatch fa-fw"></i>
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between list-group-item-warning" v-if="tempo_espera_recepcao">
                  <span class="text-muted">Espera para recepção:</span>
                  <span>
                    {{ seconds_to_time(tempo_espera_recepcao) }}
                    <i class="fas fa-stopwatch fa-fw"></i>
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between list-group-item-primary" v-if="tempo_atend_recepcao">
                  <span class="text-muted">Atendimento na recepção:</span> 
                  <span>
                    {{ seconds_to_time(tempo_atend_recepcao) }}
                    <i class="fas fa-stopwatch fa-fw"></i>
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between list-group-item-secondary" v-if="tempo_espera_pre_atend">
                  <span class="text-muted">Espera para o pré-atendimento:</span> 
                  <span>
                    {{ seconds_to_time(tempo_espera_pre_atend) }}
                    <i class="fas fa-stopwatch fa-fw"></i>
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between list-group-item-danger" v-if="tempo_espera_consultorio">
                  <span class="text-muted">Espera para o atendimento:</span> 
                  <span>
                    {{ seconds_to_time(tempo_espera_consultorio) }}
                    <i class="fas fa-stopwatch fa-fw"></i>
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between list-group-item-success" v-if="tempo_atend_consultorio">
                  <span class="text-muted">Atendimento pelo profissional:</span> 
                  <span>
                    {{ seconds_to_time(tempo_atend_consultorio) }}
                    <i class="fas fa-stopwatch fa-fw"></i>
                  </span>
                </li>
              </ul>

              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Evento</th>
                    <th>Data/Hora</th>
                    <th class="text-right">Tempo</th>
                  </tr>
                </thead>
                <tr v-if="hor.marcacao.dt_inicio_atendimento" class="table-secondary">
                  <td>
                    <div>
                        Marcado
                    </div>
                    <small class="text-muted">
                        {{ hor.marcacao.fl_portal ? 'Auto-agendamento' : '' }}
                    </small>
                  </td>
                  <td>
                    <div>
                      {{ $util.getFormatDate(hor.marcacao.dt_inicio_atendimento) }}
                    </div>
                    <small class="text-muted">
                      {{ hor.marcacao.dt_inicio_atendimento.slice(11,16) }}
                    </small>
                  </td>
                  <td></td>  
                </tr>
                <tr v-if="hor.marcacao.dt_checkin" class="table-warning">
                  <td>
                    <div>
                      Check-In
                    </div>
                    <small class="text-muted">
                      {{ hor.marcacao.st_checkin_origem }}
                    </small>
                  </td>
                  <td>
                    <div>
                      {{ hor.marcacao.dt_checkin.slice(11,16) }}
                    </div>
                    <small class="text-muted">
                      {{ $util.getFormatDate(hor.marcacao.dt_checkin) }}
                    </small>
                  </td>
                  <td></td>
                </tr>
                <tr v-if="hor.marcacao.dt_chamada_recepcao" class="table-secondary">
                  <td>
                    <div>
                      Chamada na Recepção
                    </div>
                    <small class="text-muted" v-if="hor.marcacao.st_local_recepcao">
                      {{ hor.marcacao.st_local_recepcao }}
                    </small>
                  </td>
                  <td>
                    <div>
                      {{ hor.marcacao.dt_chamada_recepcao.slice(11,16) }}
                    </div>
                    <small class="text-muted">
                      {{ $util.getFormatDate(hor.marcacao.dt_chamada_recepcao) }}
                    </small>
                  </td>
                  <td></td>
                </tr>
                <template v-if="hor.marcacao.atendimento">
                  <tr v-for="(progresso, ipx) in hor.marcacao.atendimento.progresso_atendimentos" :key="ipx"
                    :class="cor_tabela(progresso)">
                    <td>
                      <div>{{ progresso.etapa_atendimento.st_etapa_atendimento }}</div>
                      <div class="text-muted">
                        <small>
                          {{ $util.getFormatDate(progresso.dt_conclusao) }}
                        </small>
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        <small v-if="progresso.fila">
                          {{ progresso.fila.st_fila_laudo }}
                        </small>
                        <small v-else>
                          {{ 
                            progresso.etapa_atendimento.ch_tipo_atendimento == 'R' 
                            ? 'Recepção'
                            : ( progresso.etapa_atendimento.ch_tipo_atendimento == 'C'
                              ? 'Atendimento'
                              : '' )  
                          }}
                        </small>

                        <small v-if="progresso.usuario">
                          <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                          {{ progresso.usuario.st_login }}
                        </small>
                      </div>
                    </td>
                    <td>
                      <template v-if="progresso.dt_conclusao">
                        <div>
                          <i class="fas fa-play-circle fa-fw mr-1"></i>
                          {{ progresso.dt_inicio.substr(11,8) }}
                        </div>
                        <div>
                          <i class="fas fa-stop-circle fa-fw mr-1"></i>
                          {{ progresso.dt_conclusao.substr(11,8) }}
                        </div>
                      </template>
                    </td>
                    <td class="text-right">
                      {{ seconds_to_time(progresso.tempo) }}
                      <i class="fas fa-stopwatch fa-fw"></i>
                    </td>
                  </tr>
                </template>

                <template v-if="hor && hor.marcacao && hor.marcacao.timeline && hor.marcacao.timeline.eventos && hor.marcacao.timeline.eventos.length">
                    <tr v-for="(evento, ie) in hor.marcacao.timeline.eventos" :key="'ev' + ie" :class="'table-' + evento.cor">
                        <td>
                            <div>{{ evento.title }}</div>
                            <div class="small">{{ evento.subtitle }}</div>
                        </td>
                        <td>
                            <div>
                                {{ $util.getFormatDate(evento.data) }}
                            </div>
                            <div class="text-muted" v-if="evento.data">
                                {{ evento.data.slice(11,19) }}
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </template>
              </table>

              <!-- Exames -->
              <template v-if="hor && hor.marcacao && hor.marcacao.timeline && hor.marcacao.timeline.exames && hor.marcacao.timeline.exames.length">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr class="small">
                            <th>Exames</th>
                            <th>Status</th>
                            <th>Prazo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(exame, ie) in hor.marcacao.timeline.exames" :key="'ex' + ie">
                            <td class="small">{{ exame.title }}</td>
                            <td>
                                <span :class="'badge badge-' + exame.cor">{{ exame.status }}</span></td>
                            <td class="small">
                                <span v-if="exame.prazo">{{ $util.getFormatDate(exame.prazo) }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </template>

              <!-- Filas -->
              <template v-if="hor && hor.marcacao && hor.marcacao.timeline && hor.marcacao.timeline.filas && hor.marcacao.timeline.filas.length">
                <table class="table table-sm table-hover table-responsive-md">
                    <thead>
                        <tr class="small">
                            <th>#</th>
                            <th>Procedimento</th>
                            <th>Profissional</th>
                            <th>Fila</th>
                            <th>Status</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(fila, ie) in hor.marcacao.timeline.filas" :key="'fi' + ie" :class="fila.progresso ? cor_tabela(fila.progresso) : ''">
                            <td class="small">#{{ fila.id_atendimento }}</td>
                            <td class="small">{{ fila.procedimento.search }}</td>
                            <td class="small">{{ fila.medico.search }}</td>
                            <td class="small">{{ fila.fila ? fila.fila.search : '-' }}</td>
                            <td class="small">{{ fila.progresso ? fila.progresso.etapa_atendimento.st_etapa_atendimento : '-' }}</td>
                            <td class="small">
                                <span v-if="fila.progresso">
                                    {{ $util.getFormatDate(fila.progresso.dt_inicio, 'DD/MM') }}
                                    {{ fila.progresso.dt_inicio.slice(11,16) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </template>

              <!-- Sinalizadores -->
              <template v-if="hor && hor.marcacao && hor.marcacao.timeline && hor.marcacao.timeline.sinalizadores && hor.marcacao.timeline.sinalizadores.length">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th>Outros Eventos</th>
                            <th>Data/Hora</th>
                            <th class="text-right">Tempo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(sinal, ie) in hor.marcacao.timeline.sinalizadores" :key="'ex' + ie">
                            <td>
                                <i :class="sinal.sinalizador.st_icon + ( sinal.sinalizador.st_cor ? ' text-' + sinal.sinalizador.st_cor : '' )" class="fa-fw mr-2"></i>
                                {{ sinal.sinalizador ? sinal.sinalizador.search : '?' }}
                            </td>
                            <td>
                                <div v-if="sinal.created_at">
                                    <i class="fas fa-play-circle fa-fw mr-1"></i>
                                    {{ $util.getFormatDate(sinal.created_at) }}
                                    {{ sinal.created_at.substr(11,8) }}
                                    <span class="small text-muted ml-2" v-if="sinal.usuario">{{ sinal.usuario.st_login }}</span>
                                </div>
                                <div v-if="sinal.updated_at && sinal.updated_at != sinal.created_at">
                                    <i class="fas fa-stop-circle fa-fw mr-1"></i>
                                    {{ $util.getFormatDate(sinal.updated_at) }}
                                    {{ sinal.updated_at.substr(11,8) }}
                                    <span class="small text-muted ml-2" v-if="sinal.usuario_fim">{{ sinal.usuario_fim.st_login }}</span>
                                </div>    
                            </td>
                            <td class="text-right">
                                <span v-if="sinal.tempo">
                                    {{ sinal.tempo }} <i class="fas fa-stopwatch fa-fw"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from 'moment';
import AzFloatPanel from "../../util/AzFloatPanel.vue";

export default {
  data() {
    return {
      conteudo: null,
      confirmando_pagamento: false, 
      exibir_tempos: false, 
    };
  },

  components: {
    AzFloatPanel
  },

  props: {
    hor: {
      type: Object
    },
    showPrint: {
      type: Boolean,
      default: true
    },
    onlyPanel: { 
      type: Boolean,
      default: false
    },
    emergencia: { 
      type: Boolean,
      default: false
    },
    block_editar: { 
      type: Boolean,
      default: false
    },
  },

  computed: { 
    tempo_antecedencia: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento )
        return;

      const inicio = this.hor.marcacao.dt_checkin;
      const fim = this.hor.marcacao.dt_inicio;

      if ( inicio && fim && ( inicio.substr(0,16) == fim.substr(0,16) || inicio > fim ) )
        return;

      return ( inicio && fim ) ? this.calc_tempo(inicio, fim) : null; 
    },

    tempo_espera_recepcao: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento )
        return;

      const inicio = this.hor.marcacao.dt_checkin;
      const progresso = _.first(this.hor.marcacao.atendimento.progresso_atendimentos);
      const fim = progresso 
        ? ( progresso.dt_inicio ? progresso.dt_inicio : progresso.dt_conclusao )
        : "";

      if ( inicio && fim && inicio.substr(0,16) == fim.substr(0,16) )
        return;

      return ( inicio && fim ) ? this.calc_tempo(inicio, fim) : null; 
    },

    tempo_atend_recepcao: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento )
        return;

      const tempo = this.hor.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.etapa_atendimento.ch_tipo_atendimento == 'R' )
        .reduce((total, carry) => { 
          return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
        }, null);

      return tempo; 
    },

    tempo_espera_pre_atend: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento )
        return;

      const tempo = this.hor.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.id_etapa_atendimento == 11)
        .reduce((total, carry) => { 
          return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
        }, null);

      return tempo; 
    },

    tempo_espera_consultorio: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento )
        return;

      const tempo = this.hor.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.id_etapa_atendimento == 5)
        .reduce((total, carry) => { 
          return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
        }, null);

      return tempo; 
    },

    tempo_atend_consultorio: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento )
        return;

      const tempo = this.hor.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.id_etapa_atendimento == 7 || progresso.id_etapa_atendimento == 9 )
        .reduce((total, carry) => { 
          return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
        }, null);

      return tempo; 
    },

    status: function () { 
      if ( this.hor && this.hor.marcacao ) { 

        let retorno = {
          icon: 'fas fa-dot-circle',
          msg: 'Marcado. ',
          color: 'secondary',
        };

        if ( this.hor.marcacao.fl_extra ) { 
          retorno.icon = 'fas fa-exclamation-circle';
          retorno.msg = 'Extra. ';
        } else if ( this.hor.marcacao.fl_adicao_direta ) { 
          retorno.icon = 'fas fa-plus-circle';
          retorno.msg = 'Demanda Espontânea. ';
        }

        if ( this.hor.marcacao.status_confirmacao ) { 

          switch (this.hor.marcacao.status_confirmacao.substr(0,7)) {
            case 'A Confi':
              retorno.msg += 'Não Confirmada. ';
              break;

            case 'Sem Ret':
              retorno.msg += 'Sem Retorno na Confirmação. ';
              retorno.color = 'warning';
              break;

            case 'Confirm':
              if ( this.hor.marcacao.historico_status_marcacao.dt_mudanca_status == this.hor.marcacao.dt_marcacao ) { 
                retorno.color = 'info';
              } else { 
                retorno.color = 'success';
              }

              retorno.msg += 'Confirmada. ';
              break;
          }

        }

        retorno.icon += ' text-' + retorno.color;

        return retorno;

        /*
        if ( this.hor.marcacao.dt_checkin ) { 
          return { 
            icon: 'fas fa-check-circle ' + ( this.hor.marcacao.fl_extra ? 'text-danger' : 'text-success' ),
            msg: 'CheckIn Realizado ' + ( this.hor.marcacao.fl_extra ? ' (EXTRA)' : '' ),
          }
        }

        if ( this.hor.marcacao.fl_extra ) { 

          if ( this.hor.marcacao.status_confirmacao == 'A Confirmar' ) { 
            return { 
              icon: 'fas fa-plus-circle text-danger',
              msg: 'Marcação EXTRA não confirmada',
            }  
          } else { 
            return { 
              icon: 'fas fa-plus-circle',
              msg: 'Marcação EXTRA confirmada',
            }  
          }

        }

        if ( this.hor.marcacao.status_confirmacao.substr(0,7) == 'Confirm' ) { 
          return { 
            icon: 'fas fa-check-circle',
            msg: 'Marcação confirmada',
          };
        } else if ( this.hor.marcacao.status_confirmacao == 'Sem Retorno' ) { 
          return { 
            icon: 'fas fa-question-circle text-warning',
            msg: 'Marcação Sem Retorno',
          };
        }

        if ( this.hor.marcacao.fl_adicao_direta ) { 
          return { 
            icon: 'fas fa-dot-circle',
            msg: 'Demanda Espontânea',
          }
        }

        return { 
            icon: 'fas fa-question-circle text-danger',
            msg: 'Marcação não confirmada',            
          };
        */

      }

      return { 
          icon: 'far fa-clock',
          msg: 'Horário Marcado.',
          color: 'primary',
        }
    }
  },

  methods: {
    pesquisar (texto) { 
        this.$emit("pesquisar", texto);
    },
    
    seconds_to_time(seconds) { 
      return new Date(seconds * 1000).toISOString().substr(11, 8);
    },

    calc_atraso (hor) { 
      if ( !hor || !hor.marcacao || !hor.marcacao.atendimento )
        return;

      const fim = hor.marcacao.dt_checkin ? hor.marcacao.dt_checkin : hor.marcacao.atendimento.dt_inicio; 
      const inicio = hor.marcacao.dt_inicio;

      return moment(fim, "YYYY-MM-DD HH:mm:ss").diff(moment(inicio, "YYYY-MM-DD HH:mm:ss"), 'minutes');
    },

    calc_tempo (inicio, fim) { 
      if ( !inicio || !fim )
        return null;

      return moment(fim, "YYYY-MM-DD HH:mm:ss").diff(moment(inicio, "YYYY-MM-DD HH:mm:ss"), 'seconds');

      /*
      return moment
          .duration(moment(inicio, "YYYY-MM-DD HH:mm").diff(moment(fim, "YYYY-MM-DD HH:mm")))
          .humanize(false);
      */
    },

    cor_tabela (progresso) { 
      if ( progresso.id_etapa_atendimento == 5 ) 
        return 'table-danger';

      if ( progresso.etapa_atendimento.ch_tipo_atendimento == 'R' )
        return 'table-primary';

      if ( progresso.etapa_atendimento.ch_tipo_atendimento == 'C' )
        return 'table-success'; 

      return 'table-secondary';
    },

    abrir_tempos () { 
      if ( this.hor && !this.hor.marcacao ) { 
        this.$emit("selecionar", this.hor);
        return;
      }

      this.exibir_tempos = true; 

      if ( !this.hor.marcacao.timeline ) { 

        this.$util.loadItem(this, { 
            service: 'marcacoes',
            func: 'timeline',
            parms: { 
                id_marcacao: this.hor.marcacao.id_marcacao,
            },
        })
        .then(res => { 
            this.hor.marcacao.timeline = res;

            if ( res.marcacao && res.marcacao.atendimento && res.marcacao.atendimento.progresso_atendimentos ) { 
                this.hor.marcacao.atendimento.progresso_atendimentos = res.marcacao.atendimento.progresso_atendimentos;
            } 

            this.$forceUpdate();
        });

      } 

      this.$nextTick(() => { 
        $('#exibirTemosModal' + this.hor.marcacao.id_marcacao).modal('show');
      });
    },

    editar() { 
      if ( this.hor && this.hor.marcacao && !this.block_editar ) { // && this.hor.marcacao.ch_estado_marcacao == 'A' ) { 
        this.$root.editar_marcacao(this.hor.marcacao.id_marcacao, () => { 
          this.$emit('refresh');
        });
      }
    },
    verificarPagamento() { 

      $('[data-toggle="tooltip"]').tooltip('dispose');

      this.confirmando_pagamento = true; 

      this.$util.loadItem(this, { 
        service: 'pagamentos_online',
        func: 'confirmar_pagamento',
        parms: { 
          id_marcacao: this.hor.marcacao.id_marcacao,
        }
      })
      .then(res => { 
        this.$toast.add({
          severity: res.ch_status == 'E' ? 'warn' : 'success',
          summary: "Atenção",
          detail: res.status_pagamento,
          life: 3000
        });

        if ( res.ch_status != this.hor.marcacao.pagamento_online.ch_status ) { 
          this.$emit('refresh');
        }
      })
      .finally(() => { 
        this.confirmando_pagamento = false; 
      });

    },

    getHora(valor) {
      if (valor) return valor.substr(11, 5);
    },

    sync() {
      if (!this.conteudo && this.hor && this.hor.marcacao) {
        let query = {
          q: [
            {
              name: "marcacoes.show",
              id: "marcacao",
              parms: {
                id: this.hor.marcacao.id_marcacao,
                horarios: true, 
                with: [
                  "usuario.pessoa",
                  "bloqueio.bloqueioMotivo",
                  "bloqueio.usuario",
                  "historicoStatusMarcacao.usuario",
                  "atendimento.usuario.pessoa",
                  "remarcacao_origem.usuario.pessoa",
                  "remarcacao_destino.usuario.pessoa",
                  "usuario_checkin.pessoa",
                ]
              }
            }
          ]
        };

        this.axios.post("/aql", query).then(res => {
          if (res.data.marcacao.status == 200) {
            this.conteudo = res.data.marcacao.data;
          }
        });
      }
    }
  }
};
</script>